// MainFooter.jsx
import React from 'react';
import { Menu, Layout } from 'antd';
import { HomeOutlined, UserOutlined, MessageOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import NotificationBadge from '@/components/notifications';
import './index.scss';

const { Footer } = Layout;

const menuItems = [
  {
    key: '/',  // 改为路径作为 key
    label: <Link to="/" replace={true}>首页</Link>,
    icon: <HomeOutlined />,
  },
  {
    key: '/message',
    label: <Link to="/message">消息</Link>,
    icon: <NotificationBadge><MessageOutlined /></NotificationBadge>,
  },
  {
    key: '/personal',
    label: <Link to="/personal">我的</Link>,
    icon: <UserOutlined />,
  }
];

const MainFooter = () => {
  // 配置初始化
  const location = useLocation();
  // 子路由仍选中对应的一级导航，例如 /message/12 选中“消息”。
  const current = ['/message', '/personal'].find(path =>
    location.pathname === path || location.pathname.startsWith(`${path}/`)) || location.pathname;

  return (
    <Footer>
      <Menu
        selectedKeys={[current]}
        mode="horizontal"
        items={menuItems}
        disabledOverflow={true}
      />
    </Footer>
  );
};

export default MainFooter;
